module.exports = __webpack_public_path__ + "img/cmc_3.8ad195e6.png";